import React, {createContext, useContext, useEffect, useState} from 'react';

import {AlertTypeDTO} from 'kashable-mobile-common';

import {selectAlerts} from '../slices/alertsSlice';
import {NotificationUtil} from '../utils/NotificationUtil';

import {useAppSelector} from './index';

export enum AlertSelectOption {
    ALL = 'ALL',
    READ = 'READ',
    UNREAD = 'UNREAD',
}

interface IAlertsContext {
    visibleAlerts: AlertTypeDTO[];
    setVisibleAlerts: (data: AlertTypeDTO[]) => void;
    selected: AlertTypeDTO[];
    selectedAll: (data: AlertTypeDTO[]) => void;
    toggleSelected: (value: AlertTypeDTO, selected: boolean) => void;
}

const AlertsContext = createContext<IAlertsContext>({
    visibleAlerts: [],
    setVisibleAlerts: () => null,
    selected: [],
    selectedAll: () => null,
    toggleSelected: () => null,
});

export const AlertsProvider = ({children}: {children: React.ReactNode}) => {
    const alerts = useAppSelector(selectAlerts);
    const [selected, setSelected] = useState<AlertTypeDTO[]>([]);
    const [visibleAlerts, setVisibleAlerts] = useState<AlertTypeDTO[]>([]);
    const toggleSelected = (data: AlertTypeDTO, state: boolean) => {
        if (state) {
            setSelected([...selected, data]);
        } else {
            setSelected(selected.filter((item) => item.gid !== data.gid));
        }
    };
    const selectedAll = (data: AlertTypeDTO[]) => {
        setSelected(data);
    };

    const value: IAlertsContext = {
        visibleAlerts,
        setVisibleAlerts,
        selected,
        selectedAll,
        toggleSelected,
    };

    useEffect(() => {
        alerts.value && setVisibleAlerts(NotificationUtil.getRegularNotifications(alerts.value));
    }, [alerts.value]);

    return <AlertsContext.Provider value={value}>{children}</AlertsContext.Provider>;
};

export function useAlerts() {
    const context = useContext(AlertsContext);
    if (!context) {
        throw new Error('useAlerts must be used within AlertsProvider');
    }
    return context;
}
